import React, { useState, useEffect } from "react";
import logoGrups from "../assets/logo_grups.svg";
import logoUB from "../assets/logo_ub.svg";
import arrowIcon from "../assets/app_link_arrow.svg";
import "./App.css";
import { APPLE_STORE_APP_LINK, DEFAULT_APP_LINK, GOOGLE_PLAY_APP_LINK } from "../config/config";

const tenantLinks: Record<string, string> = {
  "16cd3bb3-38d0-4bb3-8dca-9bf60d78be2e": "https://somosclubub.com", // Production UUID ClubUB
  "4b182567-6cd9-439a-95e3-d0af7c28bcb1": "https://somosclubub.com", // QA UUID ClubUBold
  "550e8400-e29b-41d4-a716-446655440001": "https://somosclubub.com"  // QA UUID ClubUB
};

const isAndroid = /Android/i.test(navigator.userAgent);
const isIOS = /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);
const isChromeIOS = /CriOS/i.test(navigator.userAgent);
const isSafari = isIOS && !isChromeIOS;
const isChromeAndroid = isAndroid && /Chrome/i.test(navigator.userAgent);

function App() {

  useEffect(() => {
    if (!isSafari) {
      const timer = setTimeout(() => {
        openAppOnClick();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, []);

  const openAppOnClick = () => {
    let redirectTimer: ReturnType<typeof setTimeout>;
    let appSwitched = false;

    const cancelRedirect = () => {
      appSwitched = true;
      clearTimeout(redirectTimer);
    };

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") cancelRedirect();
    }, { once: true });

    window.addEventListener("blur", cancelRedirect, { once: true });
    window.addEventListener("pagehide", cancelRedirect, { once: true });

    // If the user dismissed the dialog, page gets focus back — cancel redirect
    window.addEventListener("focus", () => {
      if (!appSwitched) clearTimeout(redirectTimer);
    }, { once: true });

    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        appSwitched = true;
        clearTimeout(redirectTimer);
      } else if (document.visibilityState === "visible" && !appSwitched) {
        // came back without switching to app = dialog dismissed
        clearTimeout(redirectTimer);
      }
    });

    window.location.href = `grups-app:/${window.location.pathname}${window.location.search}`;

    redirectTimer = setTimeout(() => {
      window.location.href = generateRedirectUrl();
    }, 3500); // enough time for dialog to appear and user to interact
  };

  const generateRedirectUrl = (): string => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlTenant = urlParams.get('tid');

    if (urlTenant && tenantLinks[urlTenant]) {
      return tenantLinks[urlTenant];
    }

    return isIOS
      ? APPLE_STORE_APP_LINK
      : isAndroid
        ? GOOGLE_PLAY_APP_LINK
        : DEFAULT_APP_LINK;
  }

  const urlTenant = new URLSearchParams(window.location.search).get('tid');
  const isUBTenant = !!urlTenant && !!tenantLinks[urlTenant];

  return (
    <div className={`App${isUBTenant ? ' bg-ub' : ''}`}>
      <header className="App-header">
        <img
          src={isUBTenant ? logoUB : logoGrups}
          alt={isUBTenant ? "ClubUB logo" : "Grups logo"}
          className={`tenant-logo${!isUBTenant ? ' tenant-logo--grups' : ''}`}
        />

        {/* Mostrar link adicional solo en Safari */}
        {isSafari && (
          <div style={{ marginTop: 185 }}>
            <a className={`App-link${isUBTenant ? ' ub' : ''}`} onClick={(e) => { e.preventDefault(); openAppOnClick(); }} href="#">
              Ver evento
              <img src={arrowIcon} alt="" style={{ marginLeft: -5 }} />
            </a>
          </div>)}

      </header>
    </div>
  );
}

export default App;